import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({

  scoreResume: {
    marginTop: '10px',
    padding: '1.5rem',
    backgroundColor: '#EFEFEF',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: '0.15rem',
    width: '100%',

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.5rem',
    },

    '& > div > span': {
      fontWeight: 600,
    },

    '& > div > span:first-child': {
      fontWeight: 700,
    },

    '& > div > span > span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '0.25rem',
    },
  },

  info: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.25rem',

    '& p': {
      padding: '5px 0 0 5px',

      '& span': {
        fontWeight: 600,
      },
    },
  },
}))

export default styles
